module.exports = __webpack_public_path__ + "img/janvideoflow-info.e4e8aad8.jpg";